export default __webpack_public_path__ + "static/media/spiceFarm1.8dd91570.webp";